// 移植自姊妹專案 pixi_slot（FaFaCat 移植案）已驗證的 src/framework/net/balance.ts。
// 尚未接上本專案（Slot026）的真實後端，惟本專案 CLAUDE.md／UNITY_SOURCE_ANALYSIS.md 已確認
// 伺服器同樣採「金額 ×10000 整數傳輸」慣例（`ServiceUtils.ToServerBalance/ToClientBalance`），
// 故此換算係數可直接沿用。
//
// 金額轉換：伺服器整數金額 ↔ 客戶端顯示數值。對應 Unity ServiceUtils.ToClientBalance。
// 後端為避免浮點精度問題，金額一律以「真實值 × 10000」的整數傳遞；
// 前端顯示時除以 10000、保留兩位小數（見 format.ts formatMoney）。
const BALANCE_FACTOR = 10_000

/**
 * 將伺服器整數金額轉為顯示用數值（÷10000）。
 * 例：伺服器 10000 → 顯示 1；伺服器 12345 → 顯示 1.2345（呈現時由 formatMoney 取兩位）。
 */
export function toClientBalance(raw: bigint): number {
  return Number(raw) / BALANCE_FACTOR
}

/** 顯示數值 → 伺服器整數金額（×10000，四捨五入避免浮點殘差）。 */
export function toServerBalance(value: number): number {
  return Math.round(value * BALANCE_FACTOR)
}
